import { render, staticRenderFns } from "./sideAdd.vue?vue&type=template&id=2b6795f9&scoped=true&lang=html"
import script from "./sideAdd.vue?vue&type=script&lang=js"
export * from "./sideAdd.vue?vue&type=script&lang=js"
import style0 from "./sideAdd.vue?vue&type=style&index=0&id=2b6795f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6795f9",
  null
  
)

export default component.exports